import React, { useEffect, useRef, useState } from 'react';
import {
  collection, dbClient, onSnapshot, orderBy, query, where,
} from '@services/firebase.services';

type ChatMessage = {
  id: string
  isFromModerator: boolean,
  contentId: string
  text: string
  timestamp: any
  userName: string
}

type ChatWindowProps = {
  contentId: string
  dbCollectionName: string
  isForLiveBlogging: boolean
}

function PublicChatWindow({
  contentId, dbCollectionName, isForLiveBlogging,
}: ChatWindowProps) {
  const scroll = useRef<HTMLDivElement>(null);
  const [messages, setMessages] = useState<Array<ChatMessage>>([]);

  useEffect(() => {
    const msgQuery = query(collection(dbClient, dbCollectionName), where('contentId', '==', contentId), orderBy('timestamp'));
    const msgListener = onSnapshot(msgQuery, (snapshot: any) => {
      setMessages(snapshot.docs.map((doc:any) => ({ ...doc.data(), id: doc.id })));
    });
    return (() => {
      msgListener();
    });
  }, []);
  useEffect(() => {
    if (scroll.current?.parentElement) {
      if (scroll.current.parentElement.scrollTop === 0
        || scroll.current.parentElement.scrollTop + scroll.current.parentElement.offsetHeight + 84
        >= scroll.current.parentElement.scrollHeight) {
        scroll.current.parentElement.scrollTop = scroll.current.parentElement.scrollHeight;
      }
    }
  }, [messages]);

  return (
    <>
      {messages.map((msg: ChatMessage) => (
        <div key={msg.id} className={`px-2 py-1 ${!isForLiveBlogging ? 'my-1 bg-charcoal rounded-[10px]' : 'bg-white'} ${(msg.isFromModerator && !isForLiveBlogging) ? '!bg-chdBlue' : ''} `}>
          <p className={`text-[10pt] break-words ${!isForLiveBlogging ? 'text-white' : 'text-black'}`}>
            <span
              className={`font-bold break-words ${!isForLiveBlogging ? 'text-chdGreen-light' : 'text-chdBlue'} ${(msg.isFromModerator && !isForLiveBlogging) ? '!text-white' : ''}`}
            >
              {`${msg.userName}${isForLiveBlogging ? ` [${new Date(msg.timestamp.seconds * 1000).toLocaleString('en')}]` : ''}:`}
            </span>
            {' '}
            {`${msg.text}`}
          </p>
        </div>
      ))}
      <div ref={scroll} />
    </>
  );
}

export default PublicChatWindow;
